import {CacheItem} from "./CacheItem";
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {lastMap} from "../../rxjs/lastMap";
import {DS_API_URL} from "../../constants";
import {CachingService} from "./caching.service";


export class CacheDropbox extends CacheItem {
    token;
    id;

    constructor(cachingService: CachingService, httpClient: HttpClient, token: string, id: string, folder: string) {
        const url = DS_API_URL + "DropboxFileLink/" + token + id;
        super(cachingService, httpClient, url, folder, null);
        this.token = token;
        this.id = id;
    }

    protected fetchCache(url: string, folder: string): Observable<any> {
        return this.httpClient.post(this.url, {}, {headers: null, responseType: 'text'}).pipe(
            lastMap(dropboxRes => {
                const dropboxData = JSON.parse(dropboxRes);
                return new Observable(sub => {
                    fetch(dropboxData.url).then(res => {
                        return res.blob()
                    }).then(blob => {
                        caches.open(folder).then(cache => {
                            const headers = new Headers();
                            debugger;
                            this.cachingService.updateLastUsed(this.folder, this.url);

                            return cache.put(this.url, new Response(blob, {
                                status: 200,
                                statusText: '',
                                headers: headers
                            })).then(a => {
                                sub.next(url);
                                sub.complete();
                            });
                        });
                    })
                })
            })
        );
    }

    getBody(response: Response): Promise<any> {
        return response.blob();
    }

    getData(body): any {
        return this.url;
    }
}
